import React, { useState, useEffect, useRef } from "react";
import { sanitizeFileName } from "../../utils/sanitizeFileName";
import { MSG } from "../../constants/toastMessages";
import { IoCloseOutline } from "react-icons/io5";
import { toast } from "react-toastify";
import { apiCallingPost } from "../../api/services";
import axios from "axios";
import DatePicker from "react-datepicker";
import moment from 'moment';
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { MdKeyboardArrowLeft } from "react-icons/md";
import CreatableSelect from "react-select/creatable";

let selectedFile = null;
let thumbnailImg = "";

function ListUpload(props) {
  const [destinationName, setDestinationName] = useState("");
  const [destinationDescription, setDestinationDescription] = useState("");
  const [destinationFileName, setDestinationFileName] = useState("");
  const [destinationFileType, setDestinationFileType] = useState("");
  const [destinationFileDate, setDestinationFileDate] = useState("");
  const [destinationFileLocation, setDestinationFileLocation] = useState([]);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadFlag, setUploadFlag] = useState(false);
  const [selectedData, setSelectedData] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const [buttonData, setButtonData] = useState("Upload And Save");
  const [thumbnail, setThumbnail] = useState("");
  const [eventNameList, setEventNameList] = useState([]);
  const [selectedEventName, setSelectedEventName] = useState(null);
  const [selectedLocationName, setSelectedLocationName] = useState(null);

  const [folderType, setFolderType] = useState("");

  const videoRef = useRef(null);
  const canvasRef = useRef(null);

  useEffect(() => {
    getLocationNameList()
    getEventNameList()
  

    if (props.mode === "Edit") initializeEditState();
  }, []);

  useEffect(() => {
    const handleOffline = () => {
      toast.error(MSG.offline);
    };
    const handleOnline = () => {
      toast.success(MSG.backOnline);
      resumeUpload();
    };

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        props.cancelPopup();
      }
    };
    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("online", resumeUpload);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const getEventNameList = () => {
    apiCallingPost("api/common/get_all_events").then((data) => {
      if (data.data.success === "1") {
        const events = data.data.result.events || [];
        const formatted = events.map((c) => ({ value: c, label: c }));
        setEventNameList(formatted);

      } else {
        toast.error(data.data.successMessage);
      }
    }).catch((error) => {
      toast.error(MSG.genericError);
    });
  };
  const getLocationNameList = () => {
    apiCallingPost("api/common/get_all_locations").then((data) => {
      if (data.data.success === "1") {
        const Locations = data.data.result.Locations || [];
        const formatted = Locations.map((c) => ({ value: c, label: c }));
        setDestinationFileLocation(formatted);

      } else {
        toast.error(data.data.successMessage);
      }
    }).catch((error) => {
      toast.error(MSG.genericError);
    });
  };


  const initializeEditState = () => {
    const data = props.selectData;
    setSelectedData(data)
    setDestinationName(data.video_heading ?? "");
    setDestinationDescription(data.description ?? "");
    setDestinationFileName(data.qualityTypeArray.find(item => item.qualitytype === "low")?.qualityvideoname || data.url);
    setThumbnail(data.thumbnail_image)
    setDestinationFileType(data.fileTypeId);
    // setDestinationFileLocation(data.video_location);
    setDestinationFileDate(data.video_date);
    // setSelectedEventName(data.eventName)
  };
  useEffect(() => {
    if (props.mode == "Edit") {
      const savedCompany = props.selectData?.eventName; // from API/DB
      if(savedCompany && !props.selectData?.video_location){
      const existing = eventNameList.find(c => c.value === savedCompany);
      if (existing) {
        setSelectedEventName(existing);
        setFolderType("Event Name")
      }
    }
    }
  }, [eventNameList]);
  useEffect(() => {
    if (props.mode == "Edit" ) {
      const savedCompany = props.selectData?.video_location; // from API/DB          
     if(savedCompany && !props.selectData?.eventName){
      const existing = destinationFileLocation.find(c => c.value === savedCompany);      
      if (existing) {
        setSelectedLocationName(existing);
        setFolderType("Location Name")
      }
     }
      
    }
  }, [destinationFileLocation]);
  const generateResumableUrl = async (file, filePath) => {
    try {
      const postData = { fileName: filePath };
      try {
        const response = await apiCallingPost("api/common/generateResumableUrl", postData);
        if (response.data.success === "1") {
          let result = response.data.result;
          let pendingUploads = JSON.parse(localStorage.getItem("pending_upload"));
          pendingUploads.url = result;
          localStorage.setItem("pending_upload", JSON.stringify(pendingUploads));

          if (selectedData.approveStatus !== "Rejected") {
            const saveButton = document.getElementById("SaveData");
            if (saveButton) {
              saveButton.click();
            }
          }
          await uploadChunks(file, filePath, result, 0, destinationName, destinationDescription);
        } else {
          toast.error(MSG.signedUrlFailed);
        }
      } catch (error) {
        toast.error("Error generating signed URL: " + error.message);
      }
    }
    catch (e) {
      console.error("e======>", e)
    }

  };

  const uploadChunks = async (file, filePath, uploadUrl, startByte, name, description) => {
    setButtonData("Uploading...")
    const CHUNK_SIZE = 5 * 1024 * 1024;
    if (file.size <= CHUNK_SIZE) {

      try {
        await axios.put(uploadUrl.signedUrl, file, {
          headers: { "Content-Type": file.type },
          onUploadProgress: ({ loaded, total }) => {
            setUploadProgress(Math.round((loaded * 100) / total));
          },
        });
        let pendingUpload = JSON.parse(localStorage.getItem("pending_upload"));
        pendingUpload.progress = file.size;
        localStorage.setItem("pending_upload", JSON.stringify(pendingUpload));
        setUploadFlag(false);

        if (props.mode === "Add") {
          toast.success(
            MSG.dataUploaded
          );
        }
        setTimeout(() => {
          props.cancelPopup();
          props.getData("", "");
        }, 3000);
        localStorage.removeItem("pending_upload");
      } catch (error) {
        if (!navigator.onLine) {
          return;
        }
        setUploadFlag(false);
        toast.error(`Error uploading file: ${error.message}`);
        return;
      }
    }
    else {
      let start = startByte;
      while (start < file.size) {
        const end = Math.min(start + CHUNK_SIZE, file.size);
        const chunkBlob = file.slice(start, end);
        try {
          const res = await fetch(uploadUrl.signedUrl, {
            method: "PUT",
            headers: {
              "Content-Type": "application/octet-stream",
              "Content-Range": `bytes ${start}-${end - 1}/${file.size}`,
            },
            body: chunkBlob,
          });
          if (res.ok || res.status === 308) {
            start = end;
            setUploadProgress(Math.max(((start / file.size) * 100).toFixed(2), 1));
            let pendingUpload = JSON.parse(localStorage.getItem("pending_upload"));
            pendingUpload.progress = start;
            localStorage.setItem("pending_upload", JSON.stringify(pendingUpload));
            if (start >= file.size) {
              if (props.mode === "Add") {
                toast.success(
                  MSG.dataUploaded
                );
              }
              setUploadFlag(false);
              setTimeout(() => {
                props.cancelPopup();
                props.getData("", "");
              }, 2000);
              localStorage.removeItem("pending_upload");
            }
          } else {
            setUploadFlag(false);
            throw new Error(`Upload failed: ${res.statusText}`);
          }
        } catch (error) {
          if (!navigator.onLine) {
            return;
          }
          setUploadFlag(false);
          toast.error(`Error uploading chunk: ${error.message}`);
          return;
        }
      }
    }
  };
  const resumeUpload = () => {
    setUploadFlag(true);
    const storedUpload = JSON.parse(localStorage.getItem("pending_upload"));
    if (storedUpload && storedUpload.fileName) {
      uploadChunks(selectedFile, storedUpload.filePath, storedUpload.url, storedUpload.progress, storedUpload.name, storedUpload.description);
    } else {
      setUploadFlag(false);
      toast.error(MSG.uploadFailed);
    }
  };

  const clearFileUpload = () => {
    setUploadProgress(0);
    setDestinationFileName("");
  };

  const uploadData = async (videoUrlArray, name, description) => {
    setButtonData("Loading...")

    if (props.mode === "Edit") {
      if (!destinationName || !destinationDescription) {
        toast.error(MSG.fillTitleDescription);
        return;
      }
      if (selectedData.video_heading == destinationName && selectedData.description == destinationDescription &&
        selectedData.video_location == destinationFileLocation && selectedData.video_location == destinationFileDate) {
        toast.error(MSG.noChanges);
        return;
      }
    }
    setIsUploading(true)

    const postData = {
      videoName: name,
      videoPipeLineId: props.selectData.video_id || "",
      videoUrl: videoUrlArray,
      videoDescription: description,
      userId: props.mode === "Edit" ? selectedData.userId : props.userData.userId,
      createdBy: props.mode === "Edit" ? selectedData.userId : props.userData.userId,
      processedBy: props.mode === "Edit" ? selectedData.userId : props.userData.userId,
      agent: "",
      roleName: props.userData.roleDisplayName,
      from_source: "",
      videoLocation: selectedLocationName?.value ,
      videoDate: destinationFileDate ? moment((destinationFileDate)).format('YYYY-MM-DD') : "",
      eventName: selectedEventName?.value
    };

    try {
      const response = await apiCallingPost("api/video/uploadVideo", postData);
      if (response.data.success === "1") {
        if (props.mode === "Edit") {
          setIsUploading(false)
          toast.success(
            MSG.dataUpdated
          );
          setTimeout(() => {
            props.cancelPopup();
            props.getData("", "");
          }, 2000);
        }
      } else {
        toast.error(response.data.errorMessage);
      }
    } catch (error) {
      // setIsUploading(false)
      toast.error(`Error uploading data: ${error.message}`);
    }
  };

  const checkFieldsBeforeUpload = async () => {
    if (!destinationName) {
      toast.error(MSG.selectFile);
      return;
    }
    if (!destinationDescription) {
      toast.error(MSG.descriptionRequired);
      return;
    }
    setUploadFlag(true);
    setIsUploading(true)
    const config = props.getCloudBucketData
    let fileName = sanitizeFileName(selectedFile?.name);
    const dotIndex = fileName.lastIndexOf(".");
    const namePart = fileName.substring(0, dotIndex);
    const extension = fileName.substring(dotIndex);
    fileName = `${namePart}_${new Date().getTime()}${extension}`;

    const cloudFolderName = config.find(item => item.id === 7)?.config_value || "";
    const configData = config.find(item => item.id === 14)?.config_value || "";
    const cloudBucketName = config.find(item => item.id === 5)?.config_value || "";
    const file_folder = config.find(item => item.id === 18)?.config_value || "";
    const eventName = selectedEventName?.value ? "/Events/" + selectedEventName?.value : ""
    const locationName = selectedLocationName?.value ? "/Locations/" + selectedLocationName?.value : ""
    const filePath = `${cloudFolderName}/${configData}/${file_folder}${eventName?eventName:locationName}/${fileName}`;

    let mediaUrl = `https://storage.googleapis.com/${cloudBucketName}/${filePath}`

    setDestinationFileName(mediaUrl);
    const fileextension = selectedFile.name.split(".").pop().toLowerCase();
    const fileType = (selectedFile.type.includes("video") || ["mxf"].includes(fileextension)) ? "2" : selectedFile.type.includes("image") && "1";
    setDestinationFileType(fileType)
    localStorage.setItem("pending_upload", JSON.stringify({
      fileName: selectedFile.name, filePath: filePath, progress: 0,
      cloudBucketName: cloudBucketName, name: destinationName, description: destinationDescription
    }));
    await generateResumableUrl(selectedFile, filePath);

  };

  const handleFileUpload = async (e) => {
    localStorage.removeItem("pending_upload");
    selectedFile = e.target.files[0];
    setDestinationName(
      selectedFile.name.substring(0, selectedFile.name.lastIndexOf("."))
    );

    if (!selectedFile) return;
    clearFileUpload();
    const extension = selectedFile.name.split(".").pop().toLowerCase();
    if (selectedFile.type.startsWith('video') || ["mxf"].includes(extension)) {
      const videoElement = videoRef.current;
      videoElement.src = URL.createObjectURL(selectedFile);
      videoElement.addEventListener(
        "loadedmetadata",
        function captureThumb() {
          videoElement.currentTime = 0.1;
        },
        { once: true }
      );
      videoElement.addEventListener(
        "seeked",
        function drawThumbnail() {
          const canvas = canvasRef.current;
          const ctx = canvas.getContext('2d');
          canvas.width = videoElement.videoWidth;
          canvas.height = videoElement.videoHeight;
          ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);

          const thumbnailDataUrl = canvas.toDataURL('image/png');
          setThumbnail(thumbnailDataUrl);

          videoElement.removeEventListener('seeked', drawThumbnail);
        },
        { once: true }
      );
    }
    else if (selectedFile.type.startsWith('image')) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setThumbnail(e.target.result);
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  const handleChange = (selected) => {
    setSelectedEventName(selected);
  };
  const handleLocationChange = (selected) => {
    setSelectedLocationName(selected);
  };
  const handleInputChange = (inputValue, { action }) => {
    if (action === "input-change") {
      // while typing, store as selected
      setSelectedEventName({ value: inputValue, label: inputValue });
    }
  };
  const handleInputLocationChange = (inputValue, { action }) => {
    if (action === "input-change") {
      // while typing, store as selected
      setSelectedLocationName({ value: inputValue, label: inputValue });
    }
  };
  return (
    <div className="modal-admin-wrapper add-admin">
      <div className="modal-ad-popup modal-lg">
        <div className="modal-innerpopup">
          <div className="modal-headdiv d-flex justify-content-between">
            <h5 className="modal-head">File Upload</h5>
            <IoCloseOutline size={32} onClick={props.cancelPopup} />
          </div>
          <div className="modal-admin-body"
            style={{ overflow: 'unset' }}
          >
            <div className="row">
              <div className="col-md-4">
                <div className="file-area">
                  {(destinationFileName && props.mode !== "Add") &&
                    (destinationFileType == "2" ? (
                      <video controls className="object-fit-contain w-100 media-no-save"
                        poster={selectedData?.thumbnail_image}
                        onContextMenu={(event) => event.preventDefault()}>
                        <source
                          src={destinationFileName}
                          type="video/mp4"
                          key={destinationFileName}
                        />
                      </video>
                    ) : (
                      <img
                        src={destinationFileName}
                        key={destinationFileName}
                        onContextMenu={(event) => event.preventDefault()}
                        alt="Preview"
                        className="img-fluid w-100 file-upload-img media-no-save"
                        draggable={false}
                      />
                    ))}
                  {uploadFlag ? (
                    <div className="progress mx-3" style={{ marginTop: "-70px" }}>
                      <div
                        className="color"
                        style={{ width: `${uploadProgress}%` }}
                      ></div>
                      <span
                        className="percentage"
                      >
                        {uploadProgress}%
                      </span>
                      <p className="text-center w-100 text-success"
                        style={{ marginTop: "-20px" }}>Uploading...</p>
                    </div>
                  ) : (props.mode === "Add" && !thumbnail) &&
                  <>
                    <span className="text-underline theme-color mt-5 pt-5" id="upload-file">Select File</span>
                    <input
                      type="file"
                      onChange={handleFileUpload}
                    // accept="image/*,video/*"
                    />
                  </>}
                  <video ref={videoRef} style={{ display: 'none' }} />
                  <canvas ref={canvasRef} style={{ display: 'none' }} />
                  {(thumbnail && props.mode === "Add" && !isUploading) &&
                    <>
                      <img src={thumbnail} alt="Thumbnail" className="img-fluid w-100 mt-2" />
                      <IoCloseOutline title="delete media" size={20}
                        className="close-file-upload"
                        onClick={() => {
                          setThumbnail("")
                          setDestinationName("")
                        }} />
                    </>}
                </div>
              </div>
              <div className="col-md-8 mt-3 mt-lg-0">
                <input
                  className="editInput"
                  type="text"
                  placeholder="Title"
                  value={destinationName}
                  onChange={(e) => setDestinationName(e.target.value)}
                />
                <textarea
                  className="editTextInput"
                  placeholder="Description"
                  value={destinationDescription}
                  // maxLength={100}
                  onChange={(e) => setDestinationDescription(e.target.value)}
                ></textarea>



                <div className="row mx-0">
                  <div className='col-lg-5 ps-0 pe-0 pe-lg-3'  >
                    <select className="form-select editInput rounded-0" value={folderType} onChange={(e) => setFolderType(e.target.value)}>
                      <option value="">Select type</option>
                      <option value="Event Name">Event Name</option>
                      <option value="Location Name">Location Name</option>

                    </select>
                  </div>
                  <div className="col-lg-4 ps-0 pe-0 pe-lg-3 create-select-div mb-">
                    {(folderType === "Event Name") ?
                      <CreatableSelect
                        options={eventNameList}
                        value={selectedEventName}
                        onChange={handleChange}
                        onInputChange={handleInputChange}
                        placeholder="Event name"
                        isClearable={false}
                        isSearchable
                        classNamePrefix="select"
                          classNames={{
                            control: () => 'editInput py-0',
                          }}
                        formatCreateLabel={(inputValue) => `${inputValue}`} // custom text when typing
                      />
                      : (folderType === "Location Name") ?
                        <CreatableSelect
                          options={destinationFileLocation}
                          value={selectedLocationName}
                          onChange={handleLocationChange}
                          onInputChange={handleInputLocationChange}
                          placeholder="Location name"
                          isClearable={false}
                          isSearchable
                          classNamePrefix="select"
                          classNames={{
                            control: () => 'editInput py-0',
                          }}
                          formatCreateLabel={(inputValue) => `${inputValue}`} // custom text when typing
                        /> :
                        <input type='text' 
                        className='editInput mb-lg-0'
                        placeholder="Event/Location"
                        disabled={true} />}
                  </div>

                  {/* <div className="col-lg-5 ps-0 pe-0 pe-lg-2">
                    <input
                      className="editInput"
                      type="text"
                      placeholder="Location"
                      value={destinationFileLocation}
                      onChange={(e) => setDestinationFileLocation(e.target.value)}
                    />
                  </div> */}
                  <div className="col-lg-3 pe-0 ps-0 ps-lg-2">
                    <DatePicker selected={destinationFileDate} className='editInput w-100' placeholderText="Date"
                      dateFormat="dd-MM-yyyy"
                      onChange={(date) => {
                        setDestinationFileDate(date)
                      }} calendarClassName="custom-calendar"
                      renderCustomHeader={({
                        date,
                        decreaseMonth,
                        increaseMonth,
                        prevMonthButtonDisabled,
                        nextMonthButtonDisabled,
                      }) => {
                        const jsDate = new Date(date)
                        return (
                          <div className="custom-header">
                            <div className="custom-header-top">
                              <div className="day">
                                {jsDate.toLocaleDateString("en-US", {
                                  weekday: "short",
                                  month: "short",
                                  day: "numeric",
                                })}
                              </div>
                            </div>
                            <div className="custom-month-nav">

                              <span className="month-year">
                                {jsDate.toLocaleString("default", { month: "long" })} {jsDate.getFullYear()}
                              </span>
                              <div>
                                <span onClick={decreaseMonth} disabled={prevMonthButtonDisabled} className="btn-picker">
                                  <MdKeyboardArrowLeft color="#fff" size={25} />
                                </span>
                                <span onClick={increaseMonth} disabled={nextMonthButtonDisabled} className="btn-picker">
                                  <MdOutlineKeyboardArrowRight color="#fff" size={25} />
                                </span>
                              </div>

                            </div>
                          </div>
                        )
                      }
                      } />
                  </div>
                </div>
                <div className="editPanelButton d-flex justify-content-center">
                  <div>
                    {props.mode === "Add" && (
                      <button className="saveButton m-0" htmlFor="fileInput"
                        disabled={isUploading} onClick={checkFieldsBeforeUpload}>
                        {buttonData}
                      </button>
                    )}
                    {
                      <button className={`saveButton ${props.mode == `Add` && `d-none`}`} id="SaveData"
                        disabled={props.mode == `Add` ? false : isUploading}
                        onClick={() => uploadData([
                          { videoUrl: props.selectData.url || destinationFileName, fileTypeId: destinationFileType, fileName: destinationName, thumbnail_image: "" },
                        ], destinationName, destinationDescription)}>
                        Save
                      </button>
                    }
                  </div>
                  <button className="cancelButton" onClick={props.cancelPopup}>
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ListUpload;